/**
 * created by han guo qi
 * 快手页面
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ShortVideo from "../components/ShortVideo";
import {HEADER_HEIGHT, VIDEO_TYPE} from "../../../constants";
import {
    Button,
    Modal,
    Progress,
    Input,
    TreeSelect,
    Select,
    Upload,
    Tabs,
    Tag,
    Slider,
    Switch,
    Icon,
    Tooltip,
    message
} from "antd";
import moment from "moment";
import BaseComponent from "../../../base/BaseComponent";
import {isOAuthSuccess} from "../../mediaManage/actions/mediaAdminister";
import noData from '../image/noData.png'
import {uuid,permissionCheck} from "../../../utils";
import KuaishouEditPage from "../components/kuaishouEditPage";
import UploadVideo from "./uploadVideo/uploadVideo";
import Titlepicfile from "../../components/titlepicfile/Titlepicfile";
import PreviewComponent from "../components/previewComponent";
import playPic from '../image/video.png';
import {rmtMessage} from "../components/mess";
import weChatIcon from "../image/wechaticon.png"
import {getColorByState} from "../../components/colorByState/colorByState";
import CurrencyResourceDialog from "../../resource/view/dialog/CurrencyResourceDialog";
import $jq from "jquery";

const {confirm} = Modal;
const {TextArea} = Input;
const {TreeNode} = TreeSelect;
const {Option} = Select;
const {SHOW_PARENT} = TreeSelect;

let num = 0;
//ShortVideo组件高度SHOW_PARENT
let shortVideoHeight = window.innerHeight - HEADER_HEIGHT - 16;

class KuaiShou extends BaseComponent {
    static defaultProps = {};

    constructor(state) {
        super(state);
        this.state = {
            tabKey: '全部',
            tabDate: [
                {
                    key: '全部',
                    url: '/cm-sites-pms/kuaishou/pageList'
                },
                {
                    key: '已发布',
                    url: '/cm-sites-pms/kuaishou/publishList'
                },
                {
                    key: '已撤稿',
                    url: '/cm-sites-pms/kuaishou/withdraw'
                },
                {
                    key: '草稿',
                    url: '/cm-sites-pms/kuaishou/draftList'
                },
            ],//tab栏数据
            treeData: [],//同步发布其他平台下拉数据
            dataSource: [],//表格内部数据
            detailedInformationVisible: true,//详细信息弹框出现
            videoPreviewVisible: false,
            value: '',
            disable: 10, //当前用户状态是否禁用
            placeholder: "请添加视频内容描述或主题",
            rows: 4,
            display: 'block',
            maxlength: 500,
            treeSelectValue: undefined,
            mediaId: '',
            keyCode: '',
            authenticationVisible: false,//未认证弹窗的出现
            authenticationOk: null,//是否验证
            releaseVideosVisible: false,//发布视频的第一层弹框,
            uploadVideoVisible: false,//上传视频弹框
            accountInformation: {
                name: '',
                bigHead: '',
                head: '',
                follow: '',
                fan: '',
                city: '',
                sex: ''
            },//账号信息
            page: 1,
            size: 10,
            statusName: '',//tab栏状态值
            fileList: [],
            dialog: false,
            dialogKey: uuid(),
            uploadFileList: [],//上传的视频数据,
            zykFileList: [],//资源库上传数据,
            kuaishouId: '',//快手id,
            path: '',
            uploadVideoKey: uuid(),
            kuaishouEditPageKey: uuid(),
            previewVideoKey: uuid(),
            getByIData: '',
            body: {},
            // listStatusName: '',
            params: {
                mediaId: '',
                keywords: '',
                page: 1,
                size: 10,
            },
            total: 0,
            all_count: '',
            title: '状态时间',
            operateTime: 0,//发布时间和撤稿时间
            mediaTypeCode:"",//区分是抖音还是快手模块
            checkedData:[],//资源库选中的视频
            visible:false,
            muted:false,
        }
    }


    componentDidMount() {
        this.state.mediaId = this.props.match.params.mediaId;
        this.state.params.mediaId = this.props.match.params.mediaId;
        // console.log(this.props)
        this.checkSuccess();
        this.publishData();
        this.getPageList()
    }

    //点去认证到认证窗口
    jumpAuthenticationPage = () => {
        this.request({
            url: '/cm-sites-pms/kuaishou/gotoOAuth',
            body: {'mediaId': this.state.mediaId},
            callBack: (res) => {
                // console.log('认证', res)
                let keyCode = '';
                if (res) {
                    // console.log('认证', res)
                    // this.setState({kuaishouId:res.keycode})
                    window.open(res.openurl);
                    keyCode = res.keycode;
                }
                this.refreshAuth(this.state.mediaId, keyCode, "kuaishou");
            },
            errorCallBack: (e) => {
            },
        })

    }

    //刷新认证状态,校验是否验证成功
    refreshAuth(id, keyCode, mediaTypeCode) {
        let body = {
            keyCode: keyCode,
            mediaId: id,
        };
        let that = this;
        isOAuthSuccess(body, (res, status) => {
            // console.log('刷新认证状态', res)
            if (!res) {
                //反复刷新认证状态
                if (num < 100) {
                    setTimeout(function () {
                        num++;
                        that.refreshAuth(id, keyCode, mediaTypeCode);
                    }, 3000);
                }
            }
            if (res) {
                that.setState({authenticationVisible: false,})
                this.checkSuccess()
            }

        }, () => {
        }, mediaTypeCode);
    }

    //获取是否认证成功的凭证及媒体id
    checkSuccess = () => {
        this.request({
            url: '/cm-sites-pms/media/getById',
            body: {'mediaId': this.state.mediaId},
            callBack: (res) => {
                console.log('媒体数据', res)
                this.setState({
                    authenticationVisible: (res.authResult !== 1),
                    authenticationOk: res.authResult,
                    operateTime: res.operateTime,
                    disable: res.disable,
                    mediaTypeCode:res.mediaTypeCode,
                    mediaName: res.name
                })
                if (res.authResult === 1) {
                    this.getAccountInformation()
                    this.getPageList()
                }
            },
            errorCallBack: (e) => {
            },
        })
    }
    //获取快手账号信息
    getAccountInformation = () => {
        this.request({
            url: '/cm-sites-pms/kuaishou/getUserInfo',
            body: {'mediaId': this.state.mediaId},
            callBack: (res) => {
                console.log(res, "==============账号信息")
                this.setState({
                    accountInformation: {
                        name: res.name,
                        bigHead: res.bigHead,
                        head: res.head,
                        follow: res.follow,
                        fan: res.fan,
                        city: res.city,
                        sex: res.sex
                    },
                }, () => {
                    this.getProductionNumber()
                })
            },
            errorCallBack: (e) => {
            },
        })
    }
    //获取快手作品数
    getProductionNumber = () => {
        this.request({
            url: '/cm-sites-pms/kuaishou/getVideoCount',
            body: {'mediaId': this.state.mediaId},
            callBack: (res) => {
                // console.log(res, "==============快手作品数")
                this.setState({
                    all_count: res.all_count
                })
            },
            errorCallBack: (e) => {
            },
        })
    }
    // 获取分页列表
    getPageList = () => {
        let {mediaId, page, size, statusName, tabKey, tabDate, params} = this.state;
        let thisTab = tabDate.find(item => item.key == tabKey);
        let url = thisTab.url;
        this.request({
            url,
            body: params,
            callBack: (res) => {
                console.log('列表', res);
                let total = 0;
                let dataSource = [];
                if (res) {
                    total = res.count;
                    dataSource = res.data;
                }
                this.setState({
                    total, dataSource
                },()=>{
                    $jq('.ant-pagination-options-quick-jumper').find("input").val("");
                })
            },
            errorCallBack: (e) => {
            },
        })
    }
    //tab栏切换
    tabChange = (Key) => {
        this.state.tabKey = Key;
        // this.getPageList();
        this.onChange('refresh')
    };
    //撤稿
    withdrawManuscript = (id) => {
        this.request({
            url: '/cm-sites-pms/kuaishou/undo',
            body: {id},
            callBack: (res) => {
                if (res) {
                    this.getPageList()
                    rmtMessage.success("撤稿成功！")
                }
                this.setState({})
            },
            errorCallBack: (e) => {
            },
        })
    }
    //删除
    delete = (id) => {
        this.request({
            url: '/cm-sites-pms/kuaishou/deleteById',
            body: {id},
            callBack: (res) => {
                if (res) {
                    this.getPageList()
                    rmtMessage.success("删除成功！")
                }
                this.setState({})
            },
            errorCallBack: (e) => {
            },
        })
    }
    //查看及修改
    getById = (id, call) => {
        this.request({
            url: '/cm-sites-pms/kuaishou/getById',
            body: {id},
            callBack: (res) => {
                let body = null;
                if (res) {
                    body = res;
                } else {
                    message.error('获取快手信息失败');
                    return false
                }
                this.state.body = body;
                this.getStorageFileByUrl(res.videoUrl,(data)=>{
                    if(data) {
                        call && call({...body,...data});
                    }
                })
            },
            errorCallBack: (e) => {
                message.error('获取快手信息失败')
            },
        })

    };
    //获取同步发布媒体列表
    publishData = () => {
        this.request({
            url: '/cm-sites-pms/media/getVideoMediaList',
            callBack: (res) => {
                let childrenKs = [];
                let childrenDy = [];
                res.forEach(s => {
                    let currentID = window?.currentUser?.id;
                    let mediaUser = s.userIds || [];
                    if(s.authResult !== 0 && s.disable !== 1 && mediaUser.indexOf(currentID)>-1){
                        if (s.mediaTypeCode == 'douyin') {
                            if (this.state.mediaId !== s.id) {
                                childrenDy.push({
                                    title: s.name,
                                    value: s.id,
                                    key: s.id
                                })
                            }
                        };
                        if (s.mediaTypeCode == 'kuaishou') {
                            if (this.state.mediaId !== s.id) {
                                childrenKs.push({
                                    title: s.name,
                                    value: s.id,
                                    key: s.id
                                })
                            }
                        }
                    }
                });
                let treeData = [
                    {
                        title: '快手',
                        value: 'kuaishou',
                        children: childrenKs,
                        disabled:"true",
                        key: "kuaishou",
                    },
                    // {
                    //     title: '抖音',
                    //     value: 'douyin',
                    //     children: childrenDy,
                    //     disabled:"true",
                    //     key: "douyin",
                    // }
                ];
                treeData.forEach(item=>{
                    if (item.children.length){
                        item.disabled =false
                    }
                });
                this.setState({treeData:treeData})
            }
        })
    };
    //点击表格行打开弹窗,单行详情
    formDetails = (id) => {
        this.request({
            url: '/cm-sites-pms/releaseOtherPlatforms/getRecord',
            body: {
                originId: id
            },
            callBack: (res) => {
                let treeSelectValue = [];
                if(res && res.length) {
                    treeSelectValue = res.map(item=>item.mediaId);
                }
                this.getById(id, (body) => {
                    if (body) {
                        let title = "修改";
                        // this.state.listStatusName = record.statusName;
                        let accountInformation = this.state.accountInformation;
                        this.setState({}, () => {
                            this.kuaishouEditPage.show({
                                id,
                                mediaName: this.state.mediaName,
                                body,
                                title,
                                treeData:this.state.treeData,
                                accountInformation,
                                type: 'kuaishou',
                                treeSelectValue: treeSelectValue,
                                mediaTypeCode:this.state.mediaTypeCode
                            });
                        });

                    }

                });
            }
        })
    };
    //获取列表每一条数据里的视频的宽高
    getStorageFileByUrl = (url,call) => {
        this.request({
            url: '/storage/getStorageFileByUrl',
            body: {url},
            callBack: (res) => {
                if (res) {
                    let body = {
                        editWidth: res.width,
                        editHeight: res.height
                    };
                    this.state.body = {...this.state.body, ...body};
                    call&&call(body)
                } else {
                    message.error('获取视频资源信息失败')
                }
                // this.kuaishouEditPage.equalScalingImg(this.state.body)
            },
            errorCallBack: (e) => {
                message.error('获取视频资源信息失败')
            },
        })
    }
    //搜索功能
    onChange = (type, e, page, pageSize) => {
        let {params} = this.state;
        switch (type) {
            case 'onChange':
                params['keywords'] = e.target.value;
                return this.setState({});
            case 'onSearch':
                params['keywords'] = e;
                params['page'] = 1;
                break;
            case 'page':
                params['page'] = page;
                break;
            case 'size':
                params['size'] = pageSize;
                params['page'] = 1;
                break;
            case 'refresh':
                params['size'] = 10;
                params['page'] = 1;
                params['keywords'] = "";
                break;
        }
        this.getPageList();
    };


    render() {
        let height = document.body.clientHeight - HEADER_HEIGHT - 15;
        let {tabDate, dataSource, accountInformation, authenticationOk, uploadVideoKey,params} = this.state;
        let props = {
            tabDate: tabDate,
            columns: this.getColumns(),
            dataSource: dataSource,
            defaultValue: '发布图文...',
            tabChange: this.tabChange,
            tableHeight: window.innerHeight - HEADER_HEIGHT - 140 - 28 - 16 - 32 - 45 - 50 - 24 - 24,
            tableDivHeight: window.innerHeight - HEADER_HEIGHT - 140 - 16 - 28,

            tableWidth: window.innerWidth - 164.5 - 172.5,

            shortVideoHeight: shortVideoHeight,
            shortVideoWidth: this.shortVideoWidth,
            jumpAuthenticationPage: this.jumpAuthenticationPage,//跳转认证窗口
            accountInformation,
            authenticationOk,
            showReleaseVideosModal: this.showReleaseVideosModal,//发布视频弹框
            onChange: this.onChange,
            keywords: params.keywords,
            total: this.state.total,
            params: this.state.params,
            all_count: this.state.all_count,
            kuaiShouShareImg: true,
            disable:this.state.disable
        };
        //发给新增视频弹框的数据
        let EditPageProps = {
            url: {
                save: '/cm-sites-pms/kuaishou/save',
                publish: '/cm-sites-pms/kuaishou/publish',
            },
            getPageList: this.getPageList
        };
        console.log("this.state.kuaishouEditPageKey",this.state.kuaishouEditPageKey)
        return (
            <div style={{height: height, borderRadius: "2px",}}>
                <ShortVideo {...props}></ShortVideo>
                {/*认证弹窗*/}
                {this.renderAuthenticationModal()}
                {/*发布视频按钮第一层弹框*/}
                {this.renderReleaseVideos()}
                {/*本地上传,资源库弹窗*/}
                <UploadVideo key={uploadVideoKey} ref={ref => this.uploadVideo = ref}/>
                {/*/!*编辑页面组件弹窗*!/*/}
                <div key={this.state.kuaishouEditPageKey}>
                    <KuaishouEditPage
                                      {...EditPageProps}
                                      onOkCall={(refreshKey=true) => {
                                          if(refreshKey) {
                                              this.state.kuaishouEditPageKey = uuid();
                                          }
                                          this.getPageList()
                                      }} ref={ref => this.kuaishouEditPage = ref}/>
                </div>
                {/*视频预览*/}
                {this.videoPreview()}
            </div>
        );
    }


    // 视频预览
    videoPreview = () => {
        let {previewVideoKey} = this.state;
        let props = {
            weChatIcon,
            text: "微信",
        }
        return (
            <Modal
                title="视频预览"
                visible={this.state.videoPreviewVisible}
                onOk={() => {
                    this.setState({videoPreviewVisible: false})
                }}
                onCancel={() => {
                    this.setState({videoPreviewVisible: false,muted:true})
                }}
                width={400}
                style={{}}
                footer={false}
                centered
            >
                <div style={{paddingBottom: 24, marginLeft: -12}}>
                    <PreviewComponent key={previewVideoKey} {...props} muted={this.state.muted}
                                      accountInformation={this.state.accountInformation} getByIData={this.state.body}/>
                </div>

            </Modal>
        )
    };
    //表格行
    getColumns = () => {
        let tabKey = this.state.tabKey;
        return (
            [
                {
                    title: '标题',
                    dataIndex: 'title',
                    key: 'title',

                    render: (text, record) => {
                        return (
                            <div style={{display: 'flex', alignItem: 'center', flexDirection: 'row'}}>
                                {/*视频图*/}
                                <div style={{
                                    width: 80, height: 80,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}>
                                    <div style={{position: 'relative'}}>
                                        <Titlepicfile
                                            src={record.coverUrl}
                                            style={{display: 'block', margin: 'auto', width: 80, height: 80,}}
                                        />
                                        <img style={{position: 'absolute', top: 17, left: 17}}
                                             src={playPic}/>
                                    </div>
                                </div>
                                {/*标题*/}
                                <div style={{paddingLeft: '16.5px', paddingTop: '15px', cursor: 'pointer'}}
                                     onClick={() => {
                                         let id = record.id;
                                         //开启弹窗,显示表格行详情
                                         if(this.state.disable != 1){
                                             this.formDetails(id)
                                         }
                                     }}>
                                    {/*<Tooltip placement="topLeft">*/}
                                    <div style={{
                                        fontSize: '16px',
                                        width: 600,
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                    }}
                                         title={text}
                                    >
                                        {text}
                                    </div>
                                    {/*</Tooltip>*/}
                                    <div style={{display: 'flex', paddingTop: '8px', fontSize: '14px'}}>
                                        <div>
                                            浏览量：{" "}<span>{record.statistics.play || 0}</span>
                                        </div>
                                        <div style={{paddingLeft: '24px'}}>
                                            点赞：{" "}<span>{record.statistics.digg || 0}</span>
                                        </div>
                                        <div style={{paddingLeft: '24px'}}>
                                            评论：{" "}<span>{record.statistics.comment || 0}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                },
                {
                    title: '状态',
                    dataIndex: 'statusName',
                    key: 'statusName',
                    width: 200,
                    render: (text, record) => {
                        let color = getColorByState(text);
                        return (
                            <div className={'dotState'}>
                                <div style={{background: color, width: 8, height: 8, borderRadius: '50%'}}></div>
                                {text}
                            </div>
                        )
                    }
                },
                {
                    title: tabKey === "全部" ? "更新时间" : tabKey === "已发布" ? "发布时间" : tabKey === '已撤稿' ? "撤稿时间" :tabKey === '草稿' ? "更新时间" : null,
                    dataIndex: tabKey === "全部" ? "updateTime" : tabKey === "已发布" ? "dbUpdateTime" : tabKey === '已撤稿' ? "operateTime" :tabKey === '草稿' ? "updateTime" : null,
                    key: tabKey === "全部" ? "updateTime" : tabKey === "已发布" ? "dbUpdateTime" : tabKey === '已撤稿' ? "operateTime" :tabKey === '草稿' ? "updateTime" : null,
                    width: 200,
                    render: (text, record) => {
                        let time = text ? moment(text).format('YYYY-MM-DD HH:mm') : null;
                        let updateTime = record.updateTime ? moment(record.updateTime).format('YYYY-MM-DD HH:mm') : null;
                        return (
                            <div>
                                {time ? time : updateTime}
                            </div>
                        )
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    key: 'action',
                    width: 220,
                    render: (text, record) => {
                        let deleteStatus = ['撤稿','草稿','发布失败','已撤稿'];
                        return (
                            <div style={{marginLeft: '-12px',display:"flex"}}>
                                <Button type={'link'} onClick={() => {
                                    let id = record.id;
                                    this.getById(id, (body) => {
                                        if (body) {
                                            this.setState({videoPreviewVisible: true,muted:false})
                                        }
                                    });
                                    this.state.previewVideoKey = uuid()
                                }}>查看</Button>{" "}
                                {record.statusName == '发布' || record.statusName == '已发布' ?
                                    <div  style={{ visibility: this.state.disable == 1 ? "hidden" : ""}}>
                                        <Button type={'link'} onClick={() => {
                                            this.showWithdrawConfirm(record.id)
                                        }}
                                        >撤稿</Button>
                                    </div> : <></>}

                                {/*{  record.statusName == '撤稿'?<><Button type={'link'} onClick={() => {*/}
                                {/*    this.getById(record.id)*/}
                                {/*    let title="修改";*/}
                                {/*    let {body}=this.state;*/}
                                {/*    this.kuaishouEditPage.show({body,title});*/}
                                {/*}}>修改</Button>{" "}</>:<></>}*/}
                                {record.statusName == '发布' || record.statusName == '已发布' ? <div style={{ visibility: this.state.disable == 1 ? "hidden" : ""}}>
                                    <Button onClick={() => {
                                        this.visitAddress(record.id)
                                    }} type="link"
                                    >访问</Button>
                                </div> : null}
                                {(deleteStatus.indexOf(record.statusName) > -1) ?
                                    <div style={{ visibility: this.state.disable == 1 ? "hidden" : ""}}>
                                        <Button type={'link'} onClick={() => {
                                            this.showDeleteConfirm(record.id)
                                            // this.delete(record.id)
                                        }}
                                        >删除</Button>
                                    </div> : <></>}
                            </div>
                        )
                    }
                },
            ]
        )
    }
    //获取快手的访问地址
    visitAddress = (id) => {
        this.request({
            url: '/cm-sites-pms/kuaishou/getVideoInfo',
            body: {id},
            callBack: (res) => {
                console.log(res, "快手的访问地址")
                if (res) {
                    window.open(res)
                    // this.getPageList()
                }
                this.setState({})
            },
            errorCallBack: (e) => {
            },
        })
    }
    //撤稿提示框
    showWithdrawConfirm = (id) => {
        confirm({
            title: '确定要撤稿吗？',
            // content: '确定撤稿已发布的快手短视频吗？',
            onOk: () => {
                this.withdrawManuscript(id)
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    }
    //删除提示框
    showDeleteConfirm = (id) => {
        confirm({
            title: '删除提示',
            content: '确定删除该快手短视频吗？',
            onOk: () => {
                this.delete(id)
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    //发布视频按钮第一层弹框
    renderReleaseVideos = () => {
        let {mediaId} = this.state;
        return (
            <Modal
                centered
                visible={this.state.releaseVideosVisible}
                onOk={() => {
                    this.setState({
                        releaseVideosVisible: false
                    })
                }}
                onCancel={() => {
                    this.setState({
                        releaseVideosVisible: false
                    })
                }}
                width={1200}
                bodyStyle={{height: 718}}
                footer={null}
            >
                <div style={{
                    position: 'relative',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    margin: 'auto',
                    paddingTop: 32
                }}>
                    <div style={{textAlign: 'center',}}>
                        <img style={{width: 400, height: 299.37}} src={noData}/>
                        <div style={{marginTop: -30, fontWeight: 500, fontSize: 22, color: 'rgba(0,0,0,0.85)'}}>创作开始
                        </div>
                        <div>
                            <Button onClick={() => {
                                this.uploadVideo.show(this.onUploadVideoCall)
                                this.uploadVideo.empty(this.cancelEmpty)
                            }} type="primary" style={{borderRadius: 0, marginTop: 24}}>本地上传</Button>
                            {
                                permissionCheck('right_to_use_zyk')?   <Button onClick={() => {
                                    this.resourceDialog.show()
                                }}  style={{borderRadius: 0, marginTop: 24,marginLeft:24}}>资源库选择</Button>:null
                            }

                        </div>
                    </div>
                    <CurrencyResourceDialog
                        singleChoice = {true}
                        onCallBackOk={(checkedData,call)=>{
                            if (checkedData.length !=1){
                                call&&call(false);
                                rmtMessage.warning("请选择一个视频！")
                            }else {
                                call&&call(true);
                                if(checkedData[0].size/1024/1024>120){
                                    rmtMessage.destroy();
                                    rmtMessage.warning("暂不支持上传120M以上的视频！")
                                    return false;
                                }
                                this.setState({zykFileList:checkedData})
                                let body = {
                                    coverFrameCurrentTime: checkedData[0].lastModified,
                                    mediaId: this.state.mediaId,
                                    title: "",
                                    // coverUrl: checkedData[0].url,
                                    videoDuration: checkedData[0].duration,
                                    videoFileLen: checkedData[0].size,
                                    videoName: checkedData[0].name,
                                    videoUrl: checkedData[0].mp4Path,
                                    editWidth: checkedData[0].width,
                                    editHeight: checkedData[0].height
                                };
                                let title = '新增';
                                let accountInformation = this.state.accountInformation;
                                this.uploadVideo.hide();
                                let mediaTypeCode = this.state.mediaTypeCode
                                this.setState({releaseVideosVisible: false, uploadVideoKey: uuid(),kuaishouEditPageKey:uuid()},()=>{
                                    this.kuaishouEditPage.show({body, title, accountInformation,treeData:this.state.treeData,mediaTypeCode,mediaName: this.state.mediaName,});
                                });
                            }
                        }}
                        indexName={"video"}
                        ref={resourceDialog=>this.resourceDialog = resourceDialog} />
                    <div style={{display: 'flex', justifyContent: 'center', paddingTop: 80}}>
                        <div style={{
                            width: 240,
                            height: 122,
                            background: 'rgba(0,80,179,0.04)',
                            paddingLeft: 24,
                            paddingTop: 24
                        }}>
                            <p style={{fontWeight: 500, fontSize: 16}}>推荐尺寸</p>
                            <p style={{fontSize: 14, color: 'rgba(0,0,0,0.45)'}}>16:9的横版视频<br/>9:16的竖版视频</p>
                        </div>
                        <div style={{
                            width: 240,
                            height: 122,
                            background: 'rgba(0,80,179,0.04)',
                            marginLeft: 40,
                            paddingLeft: 24,
                            paddingTop: 24
                        }}>
                            <p style={{fontWeight: 500, fontSize: 16}}>视频大小</p>
                            <p style={{fontSize: 14, color: 'rgba(0,0,0,0.45)'}}>支持时长15分钟以内，最大120M<br/>的视频文件</p>
                        </div>
                        <div style={{
                            width: 240,
                            height: 122,
                            background: 'rgba(0,80,179,0.04)',
                            marginLeft: 40,
                            paddingLeft: 24,
                            paddingTop: 24
                        }}>
                            <p style={{fontWeight: 500, fontSize: 16}}>参考视频</p>
                            <p style={{fontSize: 14, color: 'rgba(0,0,0,0.45)'}}>推荐上传720p (1280x720) 及<br/>以上要求的视频</p>
                        </div>
                        <div style={{
                            width: 240,
                            height: 122,
                            background: 'rgba(0,80,179,0.04)',
                            marginLeft: 40,
                            paddingLeft: 24,
                            paddingTop: 24
                        }}>
                            <p style={{fontWeight: 500, fontSize: 16}}>视频格式</p>
                            <p style={{fontSize: 14, color: 'rgba(0,0,0,0.45)'}}>支持常用视频格式，推荐使用<br/>mp4</p>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
    showReleaseVideosModal = () => {
        this.setState({
            releaseVideosVisible: true,
        });
    }


    //认证弹框
    renderAuthenticationModal = () => {
        return (
            <Modal
                centered
                title="提示"
                visible={this.state.authenticationVisible}
                okText="认证"
                onOk={() => {
                    this.setState({
                        authenticationVisible: false,
                    });
                    this.jumpAuthenticationPage()
                }}
                onCancel={() => {
                    this.setState({
                        authenticationVisible: false,
                    });
                }}>
                <p>此账号授权已过期，认证后方可正常使用！</p>
            </Modal>
        )
    }


    // 本地上传和资源库视频选择,点击确定按钮回调
    onUploadVideoCall = (fileList) => {
        if (fileList.length != 1) {
            return rmtMessage.error('必须且只能上传一个视频。');
        }
        if ((fileList[0].duration / 1000 / 60) > 15) {
            rmtMessage.error("不可发布超过15分钟的视频。");
            return false;
        }
        if (fileList[0].status === "uploading") {
            rmtMessage.warning("正在上传，请稍等。");
            return false;
        }
        let body = {
            mediaId: this.state.mediaId,
            title: "",
            // coverUrl: fileList[0].url,
            videoDuration: fileList[0].duration,
            videoFileLen: fileList[0].size,
            videoName: fileList[0].name,
            videoUrl: fileList[0].mp4Path,
            editWidth: fileList[0].width,
            editHeight: fileList[0].height,
            treeData: this.state.treeData
        };
        this.state.body = {...this.state.body, ...body};
        let title = '新增';
        let accountInformation = this.state.accountInformation;
        this.uploadVideo.hide();
        this.setState({releaseVideosVisible: false, uploadVideoKey: uuid(),kuaishouEditPageKey:uuid()},()=>{
            this.kuaishouEditPage.show({body, title, accountInformation,treeData:this.state.treeData,mediaTypeCode:this.state.mediaTypeCode,mediaName: this.state.mediaName,});
        });
    };
    //本地上传和资源库视频选择,点击取消按钮回调
    cancelEmpty = () => {
        this.setState({uploadVideoKey: uuid()});
    }
}


KuaiShou.propTypes = {};

export default KuaiShou;